import {
    SHOW_ERROR_MESSAGE,
    HIDE_ERROR_MESSAGE,
    SHOW_UNAVAILABILITY_ALERT,
    HIDE_UNAVAILABILITY_ALERT,
} from '../actions/types'

interface MainInfosStore {
    showErrorBar: boolean
    errorMessage: string
    isSystemUnavailable: boolean
    isSystemBlocked: boolean
    unavailabilityMessage: string
}

const INITIAL_STATE: MainInfosStore = {
    showErrorBar: false,
    errorMessage: '',
    isSystemUnavailable: false,
    isSystemBlocked: false,
    unavailabilityMessage: '',
}

export default (state = INITIAL_STATE, action: any): MainInfosStore => {
    switch (action.type) {
        case SHOW_ERROR_MESSAGE:
            return {
                ...state,
                showErrorBar: true,
                errorMessage: action.playload.errMsg,
            }
        case HIDE_ERROR_MESSAGE:
            return {
                ...state,
                showErrorBar: false,
                errorMessage: '',
            }
        case SHOW_UNAVAILABILITY_ALERT:
            return {
                ...state,
                isSystemUnavailable: true,
                isSystemBlocked: action.playload.isSystemBlocked,
                unavailabilityMessage: action.playload.unavailabilityMessage,
            }
        case HIDE_UNAVAILABILITY_ALERT:
            return {
                ...state,
                isSystemUnavailable: false,
                isSystemBlocked: false,
                unavailabilityMessage: '',
            }
        default:
            return state
    }
}
